// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled {
  pointer-events: none;
  cursor: default;
  opacity: 0.6;
}

.icon-badge-gold:before {
  content: "\\e900";
  color: #f2c94c;
}

.gc-pr-12 {
  padding-right: 12px !important;
}

.gc-pl-12 {
  padding-left: 12px !important;
}

.custom-invalid {
  border: 1px solid red !important;
}

.validation-text {
  display: block;
  margin-top: 5px;
  color: red;
}

.max-img-note {
  font-size: 12px;
  margin: 8px 0 20px 0;
}

.table-header h2 {
  line-height: 1;
}
.table-header .table-search-wrapper {
  max-width: 300px;
  flex: 1 1 auto;
  margin: 0;
}
.table-header .table-calendar-wrapper,
.table-header .field,
.table-header p-button {
  margin: 0;
}
.table-header .field {
  margin-bottom: 0 !important;
}
@media (max-width: 1200px) {
  .table-header {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .table-header .table-search-wrapper {
    max-width: 100%;
    width: 100%;
  }
}

.gc-report-name {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #1F2937;
}

:host ::ng-deep .p-button.p-button-icon-only:disabled {
  color: #9CA3AF;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
